import { render, staticRenderFns } from "./AttachmentForm.vue?vue&type=template&id=5befce6c&scoped=true&"
import script from "./AttachmentForm.vue?vue&type=script&lang=js&"
export * from "./AttachmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentForm.vue?vue&type=style&index=0&id=5befce6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5befce6c",
  null
  
)

export default component.exports